import { takeEvery } from 'redux-saga/effects';
import { fetchVideoCommentsEffect } from './effects/fetch-video-comments';
import { addVideoCommentEffect } from './effects/add-video-comment';
import { removeVideoCommentEffect } from './effects/remove-video-comment';
import {
  VIDEO_COMMENT_ADD_REQUEST,
  VIDEO_COMMENT_FETCH_REQUEST,
  VIDEO_COMMENT_REMOVE_REQUEST,
} from 'components/video-box/video-comments/actions';

export const videoCommentsSaga = function* () {
  yield takeEvery(VIDEO_COMMENT_FETCH_REQUEST, fetchVideoCommentsEffect);
  yield takeEvery(VIDEO_COMMENT_ADD_REQUEST, addVideoCommentEffect);
  yield takeEvery(VIDEO_COMMENT_REMOVE_REQUEST, removeVideoCommentEffect);
};
